(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  const mark = () => document.documentElement.classList.add('ambyrtek-v5-ready');
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mark, { once: true });
  else mark();

  // Product gallery is fully native Horizon for maximum compatibility.

  // Refined add-to-cart feedback. Never intercepts the form submission.
  const toast = document.createElement('div');
  toast.className = 'ambyrtek-cart-toast';
  toast.setAttribute('role', 'status');
  toast.setAttribute('aria-live', 'polite');
  toast.innerHTML = '<span class="ambyrtek-toast-dot"></span><span class="ambyrtek-toast-text">Ajouté au panier</span>';
  document.body.appendChild(toast);

  let toastTimer;
  const showToast = () => {
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2600);
    document.documentElement.classList.add('ambyrtek-cart-pulse');
    setTimeout(() => document.documentElement.classList.remove('ambyrtek-cart-pulse'), 900);
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    window.setTimeout(showToast, 350);
  });

  // Make the cart drawer feel like a premium system panel after it opens.
  const observeCart = () => {
    const drawer = document.querySelector('#cart-drawer');
    if (!drawer || drawer.dataset.ambyrtekObserved) return;
    drawer.dataset.ambyrtekObserved = 'true';
    const observer = new MutationObserver(() => {
      const dialog = drawer.querySelector('dialog[open], .theme-drawer__dialog[open]');
      if (dialog) {
        dialog.classList.add('ambyrtek-cart-active');
        window.setTimeout(() => dialog.classList.remove('ambyrtek-cart-active'), 900);
      }
    });
    observer.observe(drawer, { attributes: true, subtree: true, attributeFilter: ['open', 'class'] });
  };
  observeCart();

  // Reveal content only when it enters the viewport; avoids a heavy first-paint animation.
  if (!reduce && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('ambyrtek-in-view');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    document.querySelectorAll('main .shopify-section, main .product-recommendations').forEach((section) => io.observe(section));
  }
})();
